import { Typography } from '@design-system/components/typography/typography';
import { SuperTooltipTemplate } from '../types';
import * as styles from './ReadMore.css';
import { IconButton } from '@design-system/components/button/iconButton';
import { faBooks } from '@fortawesome/pro-solid-svg-icons';
import { Row } from '@design-system/components/grid/grid';

export const ReadMore = (
  p: Pick<
    SuperTooltipTemplate,
    'readMoreLabel' | 'readMoreLink' | 'readMoreText'
  > & {
    onClick?: (link: string) => void;
  },
) => {
  const link = p.readMoreLabel.includes('link:');
  if (!p.readMoreText) return null;
  return (
    <div className={styles.container}>
      <Typography variant="body" size="medium" color="N-80" fontWeight="normal">
        Need more help?
      </Typography>
      <Row alignCenter>
        <Typography variant="body" size="large" fontWeight="medium">
          {p.readMoreText}{' '}
          {link && (
            <a
              href={p.readMoreLink}
              onClick={() => p.onClick?.(p.readMoreLink)}
              target="_blank"
              rel="noreferrer"
              // className={styles.link}
            >
              {p.readMoreLabel.replace('link:', '')}
            </a>
          )}
        </Typography>{' '}
        {!link && (
          <IconButton
            variant="filled"
            color="primaryTonal"
            icon={faBooks}
            onClick={() => p.onClick?.(p.readMoreLink)}
          >
            {p.readMoreLabel}
          </IconButton>
        )}
      </Row>
    </div>
  );
};
